module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/logo-72d383938c312ad58c85c9923ec1f814.svg";